import React, { Fragment,useEffect,useState } from "react";
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { totalPrice } from "../../utils";
import Footer from "../../components/footer/Footer";
import { useGetShoppingCartQuery, useRemoveShoppingCartItemMutation } from "../../api/shoppingCartApi";
import {toast} from 'react-toastify'
import IsLoading from "../../components/Loading/IsLoading";
import { cartStateUpdate } from "../../store/reducers/cartSlice";
import { MatchLocationToCurrency } from "../Extensions/MatchLocationToCurrency";
import { Helmet } from "react-helmet";
import { removeFromGuestCart } from '../../store/reducers/guestCartSlice';
import './CartPage.css';

const CartPage = (props) => {
  const userDetail = useSelector((state) => state.authStore.nameIdentifier);
  const guestCart = useSelector((state) => state.guestCartStore);

  // Only fetch server cart if user is authenticated
  const { data, isLoading } = useGetShoppingCartQuery(userDetail, {
    skip: !userDetail,
    refetchOnMountOrArgChange: true,
  });
  
  const [removeCartItem] = useRemoveShoppingCartItemMutation();
  const [courses, setCourses] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (userDetail && data) {
      // Authenticated user - use server cart
      setCourses(data.result?.courses || []);
      let jsonSerializer = JSON.stringify(data.result?.courses);
      localStorage.setItem("basketItems", jsonSerializer);
    } else {
      // Guest user - use guest cart from Redux
      setCourses(guestCart.items || []);
    }
  }, [data, userDetail, guestCart]);

  if (isLoading) {
    return <IsLoading />;
  }

  const removeFromCartHandler = async (courseId) => {
    if (userDetail) {
      // Authenticated user - remove from server
      var response = await removeCartItem(courseId);
      if (response) {
        dispatch(cartStateUpdate(response.data.result.item2));
        toast.success(response.data.messages[0]);
      }
    } else {
      // Guest user - remove from local cart
      dispatch(removeFromGuestCart(courseId));
      toast.success("Item removed from cart");
    }
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  if (!courses || courses.length === 0) {
    return (
      <Fragment>
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        <Navbar />
        <PageTitle pageTitle={"Cart"} pagesub={"Cart"} />
      
        <div className="modern-cart-area">
          <div className="modern-cart-container">
            <div className="empty-cart-state">
              <div className="empty-cart-icon">🛒</div>
              <h1 className="empty-cart-title">Your Cart is Empty</h1>
              <p className="empty-cart-message">
                Looks like you haven't added any courses yet. Start exploring and find your perfect course!
              </p>
              <Link to="/" className="continue-shopping-btn">
                Browse Courses
              </Link>
            </div>
          </div>
        </div>
        <Footer />
        <Scrollbar />
      </Fragment>
    );
  }
 
  return (
    <Fragment>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Navbar />
      <PageTitle pageTitle={"Cart"} pagesub={"Cart"} />
    
      <div className="modern-cart-area">
        <div className="modern-cart-container">
          {/* Cart Items */}
          <div className="cart-items-grid">
            {courses.map((courseItem, crt) => (
              <div key={crt} className="cart-item-card">
                {/* Book-style Course Image */}
                <div className="cart-course-image">
                  <div className="book-container">
                    <div className="book-spine"></div>
                    <div className="book-cover">
                      <img src={courseItem.courseImage} alt={courseItem.courseName} />
                      <div className="book-gradient-overlay"></div>
                    </div>
                  </div>
                </div>

                {/* Course Info */}
                <div className="cart-course-info">
                  <div className="course-title-section">
                    <h3 className="cart-course-title">{courseItem.courseName}</h3>
                  </div>

                  {/* Price and Actions */}
                  <div className="cart-price-section">
                    <div className="cart-price-display">
                      {MatchLocationToCurrency()}{courseItem.coursePrice}
                    </div>
                    <button 
                      className="remove-btn"
                      onClick={() => removeFromCartHandler(courseItem.courseId)}
                    >
                      <i className="fi ti-trash"></i>
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Cart Summary */}
          <div className="cart-summary">
            <h2 className="summary-title">Order Summary</h2>
            
            <div className="summary-row">
              <span className="summary-label">Total Courses</span>
              <span className="summary-value">
                <span className="item-count">{courses.length}</span>
              </span>
            </div>

            <div className="summary-row">
              <span className="summary-label">Total Amount</span>
              <span className="summary-value">
                {MatchLocationToCurrency()}{totalPrice(courses)}
              </span>
            </div>

            {!userDetail ? (
              <Link to="/login" className="checkout-btn">
                Sign in to Checkout
              </Link>
            ) : (
              <Link to="/checkout" className="checkout-btn">
                Proceed to Checkout
              </Link>
            )}
          </div>
        </div>
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default CartPage;
